import React from 'react';
import i18n from '../../../../../i18n';

/** Last line of every drill: what the hero counts (drill.definition.<metric>). */
export function DrillDefinitionsFooter({ definition }: { definition?: string }) {
  if (!definition) return null;
  return (
    <p className="ddrill-definition">
      <span className="ddrill-definition-label">
        {i18n.t('performance:drillUi.definitionLabel')}
      </span>
      {definition}
    </p>
  );
}
